// client/legend-cms/src/App.js
import { Admin, Resource, Layout, defaultTheme } from 'react-admin';
import merge from 'lodash/merge';
import dataProvider from './dataProvider';
import authProvider from './authProvider';

import MyAppBar from './MyAppBar';
import MyMenu from './MyMenu';
import MyLoginPage from './LoginPage';
import lessons from './lessons';
import users from './users';
import publications from './publications';
import banners from './banners';
import quizzes from './quizzes';
import reports from './userreports';
import videoReports from './videoreports';
import worldCupMatches from './worldCupMatches';
import predictionCampaigns from './predictionCampaigns';
import predictionTeams from './predictionTeams';

const myTheme = merge({}, defaultTheme, {
  palette: {
    secondary: {
      main: '#292C33',
    },
  },
});

const MyLayout = (props) => (
  <Layout {...props} appBar={MyAppBar} menu={MyMenu} />
);

const App = () => (
  <Admin
    theme={myTheme}
    layout={MyLayout}
    loginPage={MyLoginPage}
    dataProvider={dataProvider}
    authProvider={authProvider}
  >
    <Resource options={{ label: 'Usuários APP' }} name="users" {...users} />
    <Resource
      options={{ label: 'Conteúdos NJRxp' }}
      name="lessons"
      {...lessons}
    />
    <Resource
      options={{ label: 'Publicações Usuários' }}
      name="publications"
      {...publications}
    />
    <Resource
      options={{ label: 'Banners do APP' }}
      name="banners"
      {...banners}
    />
    <Resource options={{ label: 'Quizz Game' }} name="quizzes" {...quizzes} />
    <Resource
      options={{ label: 'Reports Usuários' }}
      name="reports"
      {...reports}
    />
    <Resource
      options={{ label: 'Reports Vídeos' }}
      name="video_reports"
      {...videoReports}
    />
    <Resource
      options={{ label: 'Campanhas de Palpites' }}
      name="prediction-campaigns"
      {...predictionCampaigns}
    />
    <Resource
      options={{ label: 'Times de Palpites' }}
      name="prediction-teams"
      {...predictionTeams}
    />
    <Resource
      options={{ label: 'Palpites Copa' }}
      name="world-cup-matches"
      {...worldCupMatches}
    />
  </Admin>
);

export default App;
